















































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { Option } from '~/models/shared/types'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import CFormSelectOption from '~/components/shared/configurable/form/select/CFormSelectOption.vue'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  props: formFieldProps,
  components: {
    CFormSelectOption,
    FieldError
  },
  setup(props) {
    const { specs, name } = props

    const yearValue = ref(null)
    const monthValue = ref(null)
    const yearError = ref(null)
    const monthError = ref(null)

    function onValue(v: Ref<any>) {
      yearValue.value = v.value?.year || null
      monthValue.value = v.value?.month || null
    }
    function onError(e: Ref<any>) {
      if (e.value) {
        const { year, month } = e.value
        yearError.value = year
        monthError.value = month
      }
    }
    const { valueChanged } = useClassifiedForm(props, { onValue, onError })

    const monthsOptions: Option[] = computed(() =>
      specs.months.map(o => ({
        text: o.name,
        value: o.value
      }))
    )
    const yearsOptions: Option[] = computed(() => {
      // could use the createContiguousRange util here but would have to iterate twice for texts
      const options = []
      for (let i = specs.years.max; i >= specs.years.min; i--) {
        options.push({ text: i.toString(), value: i })
      }
      return options
    })

    const handleValueChange = () => {
      yearError.value = null
      monthError.value = null
      if (!monthValue.value && !yearValue.value) {
        valueChanged(name, null)
        return
      }
      valueChanged(name, { year: yearValue.value, month: monthValue.value })
    }

    return {
      monthsOptions,
      yearsOptions,
      yearValue,
      monthValue,
      yearError,
      monthError,
      handleValueChange
    }
  }
})
